import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VSelect, {
    attrs: {
      "value": _vm.getByKey('chartOptions.heatmap.valueDetermination', 'max'),
      "items": _vm.valueDeterminations,
      "item-text": "text",
      "item-value": "value",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.heatmap.valueDetermination.label')
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.heatmap.valueDetermination', $event);
      }
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.heatmap.lowestHeatValue', 0),
      "type": "number",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.heatmap.lowestHeatValue.label')
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.heatmap.lowestHeatValue', $event, 'number');
      }
    }
  })], 1), _c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.heatmap.highestHeatValue', 100),
      "type": "number",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.heatmap.highestHeatValue.label')
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.heatmap.highestHeatValue', $event, 'number');
      }
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };